import React from 'react'
import SuperUserLoanPageUI from '../../../templates/SuperUserLoanPageUI'
import GenericErrorUI from '../../../components/common/GenericErrorUI'
import SpinnerComponentUI from '../../../components/common/SpinnerComponentUI'
import LRTableActionsUI from '../../../widgets/layout/LRTableActionsUI'
import IconButtonUI from '../../../widgets/action/IconButtonUI'
import SelectSingleSF from '../../../widgets/input/SelectSingleSF'
import TokensNavUI from '../../../components/superUser/loan/util/TokensNavUI'
import LoanProperty2ListSF from '../../../components/superUser/loan/util/LoanProperty2ListSF'
import AnnexureDocumentUploadSF from '../../../components/superUser/loan/util/AnnexureDocumentUploadSF'
import './TokenListPage.css'

const TransactionTokenListPageUI = ({
  context,
  errorList,
  loan,
  propertyList,
  selectedDocType,
  docTypeOptionList,
  onDocTypeChange,
  onRefreshClick,
}) =>
  <SuperUserLoanPageUI context={context} className='pg_su_tl'
    backLink={`/su/${loan && loan.status === 'closed' ? 'closedLoans' : 'loans'}`}
    headerText={loan ? (loan.account.accountName + ' ' + (loan.loanName || '')) : 'Loan'}
    centered={!loan || !errorList || !propertyList} loan={loan} page='tokenS'
    dimension='w768'
  >
    {
      (!loan || !errorList || !propertyList) &&
      <SpinnerComponentUI />
    }
    {
      errorList && errorList.length > 0 &&
      <GenericErrorUI error={errorList[0]} />
    }
    {
      loan && propertyList &&
      <div>
        <LRTableActionsUI location='top'
          left={
            <span className='g_flex_left g_flex_h'>
              <IconButtonUI icon='icon-refresh' onClick={onRefreshClick} />
              <span className='g_m_left_100 g_large'><b>Tokens</b></span>
            </span>
          }
          right={
            <span className='g_select_container'>
              <SelectSingleSF
                optionList={docTypeOptionList}
                selectedKey={selectedDocType || 'all'}
                onChange={onDocTypeChange}
                placeholder='Document type'
              />
            </span>
          }
        />

        <TokensNavUI context={context} loan={loan} page='tokenT' />

        {
          loan.loanSubType === 'ppa' &&
          <LoanProperty2ListSF context={context} loan={loan} onRefreshClick={onRefreshClick}
            category='ppa_uw' categoryLabel='PPA tokens' propertyList={propertyList}
          />
        }

        {
          loan.loanSubType === 'vehicle_loan' &&
          <LoanProperty2ListSF context={context} loan={loan} onRefreshClick={onRefreshClick}
            category='ev_uw' categoryLabel='EV tokens' propertyList={propertyList}
          />
        }
        {
          (loan.loanSubType === 'standard' || loan.loanSubType === 'epc') &&
          <LoanProperty2ListSF context={context} loan={loan} onRefreshClick={onRefreshClick}
            category='po_uw' categoryLabel='PO tokens' propertyList={propertyList}
          />
        }
        {
          (loan.loanSubType === 'nbfc' || loan.loanSubType === 'nbfc_vehicle') &&
          <LoanProperty2ListSF context={context} loan={loan} onRefreshClick={onRefreshClick}
            category='nbfc_uw' categoryLabel='NBFC tokens' propertyList={propertyList}
          />
        }
        {
          (loan.loanSubType === 'ppa' || loan.loanSubType === 'vehicle_loan') &&
          (selectedDocType === 'loan_agreement' || selectedDocType === 'all') &&
          <AnnexureDocumentUploadSF
            context={context}
            loan={loan}
            onRefreshClick={onRefreshClick}
          />
        }
        <LoanProperty2ListSF context={context} loan={loan} onRefreshClick={onRefreshClick}
          category='pledge_ndu_uw' categoryLabel='Pledge/NDU tokens' propertyList={propertyList}
        />

      </div>
    }
  </SuperUserLoanPageUI>

export default TransactionTokenListPageUI
